import React from "react";

import "./comment_box.less";
import { Note } from "@src/types";
import { formatDate, getInitials } from "@src/utils/helper";
import { Avatar } from "antd";

interface CommentBoxProps {
  note: Note;
}

const CommentBox: React.FC<CommentBoxProps> = ({ note }) => {
  return (
    <div className="comment-box avatar-comment-section" key={note.id}>
      <Avatar>{getInitials(note.employeeFullName)}</Avatar>
      <div className="comment-box-text-container">
        <div>
          <span className="comment-box-text-container-name">
            {note.employeeFullName}
          </span>
          <span className="comment-box-text-container-date">
            on {formatDate(note.createdDate)}
          </span>
        </div>
        <span className="comment-box-text-container-text">{note.text}</span>
      </div>
    </div>
  );
};

export default CommentBox;
